import { render, staticRenderFns } from "./LightLogCom.vue?vue&type=template&id=9abdd4aa&"
import script from "./LightLogCom.vue?vue&type=script&lang=ts&"
export * from "./LightLogCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports